(function () {
  'use strict';

  angular
    .module('histExpurgo')
    .config(config);

  function config($stateProvider) {
    $stateProvider
      .state('root.histExpurgo', {
        url: '/historico-expurgo?vfiltro=',
        views: {
          'content@': {
            templateUrl: 'expurgo/hist-expurgo/hist-expurgo.tpl.html',
            controller: 'HistExpurgoCtrl',
            controllerAs: 'ctrl'
          }
        },
        data: {
          titulo: 'core-permissoes.purge.dismissalHistory',
          role: 'ABONO_VISUALIZAR'
        }
      });
  }
}());
